import History from "../store/History";

export function NavTo(path: string, from?: string ) {
    History.push({pathname: path, search: History.location.search, state: { from }})
}

export function LaunchTo(url: string) {
    window.open(url, '_top')
}

export default function emptyCache(){
    if('caches' in window){
        caches.keys().then((names) => {
            names.forEach(name => {
                caches.delete(name);
            })
        });
        // Makes sure the page reloads. Changes are only visible after you refresh.
        window.location.reload();
    }
}

export function GoBack() {
    History.goBack();
}
